// const showExcept = (indexToShow, fields) => {
// console.log("selected_send_group.js showExcept called with:", indexToShow, fields);
//   fields.forEach((item, index) => {
//     if(index !== indexToShow) {
//       item.hide();
//     } else {
//       item.show();
//     }
//   })
// }

// function showGroupFunction(value, fields) {
//   console.log(value)
//   switch(value) {
//     case 'select_type':
//       showExcept(0, fields)
//       break;
//     default:
//       showExcept(100, fields)
//   }
// }

// $(document).ready(function(){
//   const patronCategoryFields = $("#patron_catagory_fields").hide();

//   const hideFields = [
//     patronCategoryFields
//   ]

//   $(".send_to_buttons input[type=radio]:checked").each( function() {
//     showGroupFunction(this.value, hideFields);
//   });

//   $(".send_to_buttons")
//     .find("input[type=radio]")
//     .change(function() {
//       showGroupFunction(this.value, hideFields);
//     });
// });

function showGroupFunction(value) {
  if (value === 'select_type') {
    $("#patron_catagory_fields").show();
  } else {
    $("#patron_catagory_fields").hide();
  }
}

$(document).on("turbo:load", function () {
  const checked = $(".send_to_buttons input[type=radio]:checked");
  if (checked.length > 0) {
    showGroupFunction(checked.val());
  } else {
    $("#patron_catagory_fields").hide();
  }

  $(".send_to_buttons input[type=radio]").on("change", function () {
    showGroupFunction(this.value);
  });
});
